import { useCallback, useRef } from 'react';
import { isFunction } from 'lodash-es';

type Callback<T> = (params: null | T) => any;

const useRefWithCallback = <T>(onMount?: Callback<T>, onUnmount?: Callback<T>) => {
  const nodeRef = useRef(null);

  const setRef = useCallback(
    (node: any) => {
      if (nodeRef.current && isFunction(onUnmount)) {
        onUnmount(nodeRef.current);
      }

      nodeRef.current = node;

      if (nodeRef.current && isFunction(onMount)) {
        onMount(nodeRef.current);
      }
    },
    [onMount, onUnmount]
  );

  return setRef;
};

export default useRefWithCallback;
